import * as graphics from "@client/app/graphics";
import {BUTTON_CLASS} from "@client/components/styles";
import * as auth from "@client/features/auth";
import * as forms from "@client/forms";
import * as router from "@client/router";
import * as typography from "@client/shared/typography";
import {server} from "@reactivated";
import * as React from "react";

export const PasswordReset = router.PasswordReset.withHooks(() => {
    return {
        form: forms.useForm(server.core.rpc.ResetPassword),
    };
})
    .withIndex((props) => (
        <div style={{display: "flex", gap: 15, flexDirection: "column"}}>
            <forms.Field field={props.form.fields.email} />
            <typography.P>
                Remembered your password?{" "}
                <router.Link route="login.index" params={{}}>
                    Login
                </router.Link>
                .
            </typography.P>
        </div>
    ))
    .withActions((props) => [
        {
            icon: "custom-0763-enter-right",
            title: "Submit",
            onClick: async () => {
                const response = await forms.submitForm(
                    props.form,
                    server.core.rpc.reset_password,
                );
                if (response?.type === "success") {
                    props.notify(
                        "If an account exists with this email, reset instructions were sent to your email address.",
                    );
                    props.form.reset();
                    void props.analytics.track("PASSWORD_RESET_SUCCESS");
                }
            },
        },
    ])
    .withOptions(() => ({
        title: "Reset Password",
    }));

export const SetPassword = router.SetPassword.withHooks((props) => {
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const form = forms.useForm(server.core.rpc.SetPassword);

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            const response = await forms.submitForm(form, (data) =>
                server.core.rpc.set_password({
                    ...data,
                    uidb64: props.params.uidb64,
                    token: props.params.token,
                }),
            );
            if (response == null) return;
            if (response.type === "success") {
                void props.analytics.track("SET_PASSWORD_SUCCESS");
                await props.dispatch(
                    auth.postLogin(response.data, props.profile == null),
                );
                void router.push("today.journal", {});
            } else if (response.type !== "invalid") {
                props.notify("An error occurred. Please try again.", {type: "error"});
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        uidb64: props.params.uidb64,
        token: props.params.token,
        form,
        handleSubmit,
        isSubmitting,
    };
})
    .withIndex((props) => {
        const LIGHT_INPUT_WRAPPER_CLASS =
            "has-focus:ring-[#7D50FF] has-focus:ring-2 flex items-center pr-1 w-full rounded-sm bg-white border border-gray-300";
        const LIGHT_INPUT_CLASS =
            "min-w-0 flex-1 border-0 bg-transparent px-6 py-4 font-inter font-extralight text-gray-900 placeholder:opacity-70 placeholder:font-extralight placeholder:text-gray-500 placeholder:font-inter focus:outline-hidden focus:ring-0";
        const LABEL_CLASS = "font-light text-lg flex flex-col gap-2 text-gray-700";

        return (
            <form className="mt-4 flex flex-col gap-6">
                <label className={LABEL_CLASS}>
                    New Password
                    <div className={LIGHT_INPUT_WRAPPER_CLASS}>
                        <forms.Widget
                            field={props.form.fields.new_password1}
                            className={LIGHT_INPUT_CLASS}
                        />
                    </div>
                </label>
                <label className={LABEL_CLASS}>
                    Confirm New Password
                    <div className={LIGHT_INPUT_WRAPPER_CLASS}>
                        <forms.Widget
                            field={props.form.fields.new_password2}
                            className={LIGHT_INPUT_CLASS}
                        />
                    </div>
                </label>
                <typography.AsyncButton
                    type="button"
                    className={BUTTON_CLASS}
                    forceLoading={props.isSubmitting}
                    disabled={
                        !props.form.validated.success ||
                        props.form.values.new_password1 !=
                            props.form.values.new_password2
                    }
                    onClick={props.handleSubmit}
                >
                    Set Password
                </typography.AsyncButton>
            </form>
        );
    })
    .withActions(() => [])
    .withOptions(() => ({
        title: "Set New Password",
        titleSection: (
            <div>
                <graphics.Logo className="size-20" />
            </div>
        ),
    }));
